enum SubmittedItemsTitle {
  ComfirmedItems,
  WaitingItems,
  AllItems,
  NewItems
}

export default SubmittedItemsTitle
